<template>
  <el-tabs v-model="activeName" @tab-remove="removeTab">
    <el-tab-pane label="列表" name="list">
      <List ref="list" :operateBtn="operateBtn" />
    </el-tab-pane>
    <el-tab-pane v-if="billPage" label="单据" name="bill" closable>
      <Bill ref="bill" :removeTab="removeTab" />
    </el-tab-pane>
    <el-tab-pane v-if="detailPage" label="详情" name="detail" closable>
      <Bill ref="detail" :removeTab="removeTab" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List';
import Bill from './Bill';

export default {
  name: 'outside-application',
  components: {
    List,
    Bill,
  },
  data() {
    return {
      activeName: 'list',
      billPage: false,
      detailPage: false,
    };
  },
  watch: {},
  methods: {
    removeTab(val, name) {
      this[`${val}Page`] = false;
      this.activeName = name ? name : 'list';
      this.$refs[this.activeName].getList();
    },
    operateBtn(val, data) {
      this.activeName = val;
      this[`${val}Page`] = true;
      this.$nextTick(() => {
        this.$refs[val].getDetail(data);
      });
    },
  },
};
</script>
